import { render, staticRenderFns } from "./RegistrationPage.vue?vue&type=template&id=6d2721ba&scoped=true"
import script from "./RegistrationPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationPage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationPage.vue?vue&type=style&index=0&id=6d2721ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2721ba",
  null
  
)

export default component.exports